import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';
    const travelType = getValueOrDefault(formConfig, formValues, 'travelType').value;
    const soughtTreatmentDuringTrip = getValueOrDefault(formConfig, formValues, 'soughtTreatmentDuringTrip').value;
    const prescribedHospitalizationOrIndoorStay = getValueOrDefault(
        formConfig,
        formValues,
        'prescribedHospitalizationOrIndoorStay'
    ).value;
    const anyDaysPreventedToSki = getValueOrDefault(formConfig, formValues, 'anyDaysPreventedToSki').value;

    switch (curPageId) {
        // =============================================================
        // Step 0: Landing page
        // =============================================================
        case 'godt-at-vide':
            nextPage = 'hvem-er-syg-skadet';
            break;

        // =============================================================
        // Step 1: About the sickness or injury
        // =============================================================
        // page 1
        case 'hvem-er-syg-skadet':
            const affectedPerson = getValueOrDefault(formConfig, formValues, 'whoHasBeenIllOrInjured').value;

            if (affectedPerson === 'someoneElse') {
                nextPage = 'oplysninger-om-person';
            } else {
                nextPage = 'rejsetype';
            }
            break;

        // page 1A
        case 'oplysninger-om-person':
            nextPage = 'rejsetype';
            break;
        // page 2
        case 'rejsetype':
            nextPage = 'dato';
            break;
        // page 3
        case 'dato':
            nextPage = 'beskriv-skaden';
            break;
        // page 4
        case 'beskriv-skaden':
            nextPage = 'laegehjaelp';
            break;
        // page 5
        case 'laegehjaelp':
            if (soughtTreatmentDuringTrip === 'yes') {
                nextPage = 'dato-for-laegebesoeg';
            } else {
                nextPage = 'land';
            }
            break;
        // page 5AA
        case 'dato-for-laegebesoeg':
            if (travelType === 'otherTrip') {
                nextPage = 'indlaeggelse';
            } else {
                nextPage = 'nogle-dage-uden-ski';
            }
            break;
        // page 5A
        case 'indlaeggelse':
            if (prescribedHospitalizationOrIndoorStay === 'yes') {
                nextPage = 'dato-for-indendoers-ophold';
            } else {
                nextPage = 'land';
            }
            break;
        // page 5B
        case 'dato-for-indendoers-ophold':
            if (travelType === 'skiVacation') {
                nextPage = 'nogle-dage-uden-ski';
            } else {
                nextPage = 'land';
            }
            break;

        case 'nogle-dage-uden-ski':
            nextPage = 'dage-uden-ski';

            if (anyDaysPreventedToSki === 'no') {
                nextPage = 'land';
            }

            break;

        // page 6
        case 'dage-uden-ski':
            nextPage = 'land';

            break;
        // =============================================================
        // Step 2: About the travel
        // =============================================================
        // page 7
        case 'land':
            nextPage = 'dato-for-rejsen';
            break;
        // page 8
        case 'dato-for-rejsen':
            nextPage = 'rejsens-formaal';
            break;
        // page 9
        case 'rejsens-formaal':
            const travelPurpose = getValueOrDefault(formConfig, formValues, 'travelPurpose').value;

            if (travelPurpose === 'business') {
                nextPage = 'om-virksomheden';
            } else if (travelPurpose === 'businessAndPrivate') {
                nextPage = 'kombineret-rejse';
            } else if (soughtTreatmentDuringTrip === 'yes') {
                nextPage = 'personer-i-feriebolig';
            } else {
                nextPage = 'dokumentation';
            }

            break;
        // page 9A
        case 'om-virksomheden':
            if (
                soughtTreatmentDuringTrip === 'yes' &&
                (prescribedHospitalizationOrIndoorStay === 'yes' || anyDaysPreventedToSki === 'yes')
            ) {
                nextPage = 'personer-i-feriebolig';
            } else if (soughtTreatmentDuringTrip === 'yes' && anyDaysPreventedToSki === 'no') {
                nextPage = 'udgifter-til-sygdommen';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        // page 9B
        case 'kombineret-rejse':
            if (
                soughtTreatmentDuringTrip === 'yes' &&
                (prescribedHospitalizationOrIndoorStay === 'yes' || anyDaysPreventedToSki === 'yes')
            ) {
                nextPage = 'personer-i-feriebolig';
            } else if (soughtTreatmentDuringTrip === 'yes' && anyDaysPreventedToSki === 'no') {
                nextPage = 'udgifter-til-sygdommen';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        // page 10
        case 'personer-i-feriebolig':
            if (
                (travelType === 'skiVacation' && anyDaysPreventedToSki === 'yes') ||
                (travelType === 'otherTrip' && prescribedHospitalizationOrIndoorStay === 'yes')
            ) {
                nextPage = 'hvilken-ferie';
            } else {
                nextPage = 'udgifter-til-sygdommen';
            }

            break;
        // page 11
        case 'hvilken-ferie':
            const selfDriveHoliday = getValueOrDefault(formConfig, formValues, 'selfDriveHoliday').value;
            if (selfDriveHoliday === 'yes') {
                nextPage = 'hvilken-bil';
            } else {
                nextPage = 'udgifter-til-sygdommen';
            }
            break;
        // page 12
        case 'hvilken-bil':
            const carType = getValueOrDefault(formConfig, formValues, 'carType').value;
            if (carType === 'privateCar') {
                nextPage = 'antal-km';
            } else {
                nextPage = 'udgifter-til-sygdommen';
            }
            break;
        // page 12A
        case 'antal-km':
            nextPage = 'udgifter-til-sygdommen';
            break;
        // =============================================================
        // Step 3: About the expenses
        // =============================================================
        // page 13
        case 'udgifter-til-sygdommen':
            if (
                (travelType === 'skiVacation' && anyDaysPreventedToSki === 'yes') ||
                (travelType === 'otherTrip' && prescribedHospitalizationOrIndoorStay === 'yes')
            ) {
                nextPage = 'udgifter-til-transport-bolig';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        // page 14
        case 'udgifter-til-transport-bolig':
            nextPage = 'refundering-af-udgifter';
            break;
        // page 15
        case 'refundering-af-udgifter':
            const travelExpensesRefunded = getValueOrDefault(formConfig, formValues, 'travelExpensesRefunded').value;
            if (travelExpensesRefunded === 'yes') {
                nextPage = 'hvad-er-refunderet';
            } else {
                nextPage = 'husstandens-samlede-udgifter';
            }
            break;
        // page 15A
        case 'hvad-er-refunderet':
            nextPage = 'husstandens-samlede-udgifter';
            break;
        // page 16
        case 'husstandens-samlede-udgifter':
            nextPage = 'dokumentation';
            break;
        // =============================================================
        // Step 4: Documentation
        // =============================================================
        // page 17
        case 'dokumentation':
            nextPage = 'anden-rejseforsikring';
            break;

        // =============================================================
        // Step 5: About you
        // =============================================================
        // page 18
        case 'anden-rejseforsikring':
            const otherTravelInsuranceCoverage = getValueOrDefault(
                formConfig,
                formValues,
                'otherTravelInsuranceCoverage'
            ).value;
            if (otherTravelInsuranceCoverage === 'yesThroughMastercard') {
                nextPage = 'anden-rejseforsikring-mastercard';
            } else if (otherTravelInsuranceCoverage === 'yesThroughOtherInsuranceCompany') {
                nextPage = 'anden-rejseforsikring-forsikringsselskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        // page 18A
        case 'anden-rejseforsikring-forsikringsselskab':
            nextPage = 'om-dig';
            break;
        // page 18B
        case 'anden-rejseforsikring-mastercard':
            nextPage = 'om-dig';
            break;
        // page 19
        case 'om-dig':
            nextPage = 'resume';
            break;
        // =============================================================
        // Step 6: Summery
        // =============================================================
        case 'resume':
            nextPage = undefined;
            break;
        default:
            console.log('# curPageId=', curPageId);
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
